import { useQuery } from '@tanstack/react-query';
import { notificationsService } from '../services/notifications.service';

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => notificationsService.list(),
    refetchInterval: 30000, // poll a cada 30s
    staleTime: 10000,
  });
}
